<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-col class="com-mb-graph pa-0" ref="graphBox">
        <v-row class="com-mb-card-header">
          <span class="com-mb-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="white" @click="$emit('close')">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-col class="com-mb-card-contents py-1">
          <div v-if="this.isDispCross" style="width:100%">
            <kwb-com-cross
              v-bind:windowWidth="width"
              v-bind:windowHeight="height"
              v-bind:scrollMode="selectDisp"
              v-bind:showLegend="isLegendDisp"
              v-bind:crossData="this.cross"
              v-bind:sliderIdx="this.sliderIndex"
              @setDispIndex="0"
            ></kwb-com-cross>
            <!-- <v-row>
              <v-col
                sm="3"
                class="mt-1 pr-0 py-0"
                style="font-size:0.85rem; color: grey;text-align: center;"
                >{{ sliderText }}</v-col
              >
              <v-col sm="9" class="px-0 py-0"
                ><v-slider
                  class="mr-3"
                  v-model="sliderIdx"
                  dense
                  hide-details
                  min="0"
                  :max="sliderMax"
                  :step="sliderStep"
                >
                  <template v-slot:prepend>
                    <v-icon
                      :disabled="!ablePrepend()"
                      color="success"
                      @click="prependCross()"
                      >fast_rewind</v-icon
                    >
                  </template>
                  <template v-slot:append>
                    <v-icon
                      :disabled="!ableAppend()"
                      color="success"
                      @click="appendCross()"
                      >fast_forward</v-icon
                    >
                  </template>
                </v-slider></v-col
              >
            </v-row> -->
            <v-col class="pa-0">
              <v-row class="tm-mb-graph-select-box pa-1">
                <v-spacer></v-spacer>
                <v-btn
                  tile
                  depressed
                  x-small
                  color="success"
                  width="50px"
                  :outlined="selectDisp === true"
                  @click="selectDisp = false"
                  >{{ btn.zoomout }}</v-btn
                >
                <v-btn
                  tile
                  depressed
                  x-small
                  color="success"
                  width="50px"
                  :outlined="selectDisp === false"
                  @click="selectDisp = true"
                  >{{ btn.zoomin }}</v-btn
                >
                <v-btn
                  tile
                  depressed
                  x-small
                  color="success"
                  width="50px"
                  :outlined="selectTime === false"
                  @click="selectTime = true"
                  class="ml-1"
                  >{{ btn.timehour }}</v-btn
                >
                <v-btn
                  tile
                  depressed
                  x-small
                  color="success"
                  width="50px"
                  :outlined="selectTime === true"
                  @click="selectTime = false"
                  >{{ btn.time10 }}</v-btn
                >
                <v-btn
                  depressed
                  x-small
                  color="orange"
                  width="50px"
                  dark
                  :outlined="!isLegendDisp"
                  @click="isLegendDisp = !isLegendDisp"
                  class="ml-1 mr-1"
                >
                  <v-icon small>import_contacts</v-icon>
                  {{ btn.legend }}
                </v-btn>
              </v-row>
            </v-col>
          </div>
        </v-col>
      </v-col>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]水位 河川横断図ダイアログ
 * TmStageXSecDlg.vue
 * @author ILUKE
 */

import KwbComCross from "./KwbComCross";
import geodesic from "./../../lib/geodesic.js";
import drawCross from "./../../lib/drawCross.js";
import WebStorage from "./../../lib/webStorage.js";
import tmObs from "./../../lib/tmObs.js";
export default {
  name: "tm-stage-x-sec",
  components: {
    KwbComCross,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "横断図",
      },
      btn: {
        timehour: "時間毎",
        time10: "10分毎",
        zoomout: "全体",
        zoomin: "拡大",
        legend: "凡例",
      },
      dispConfFlg: false,
      active: false,
      cross: {},
      isDispCross: false,
      isScrollMode: true,
      isShowLegend: false,
      sliderIdx: 0,
      predStep: 7,
      selectTime: true,
      selectDisp: true,
      isLegendDisp: false,
      width: 10,
      height: 10,
    };
  },
  props: {
    /** 拡大/全体指定 */
    isExpansion: {
      type: Boolean,
      default: true,
    },
    /** 時間/10分指定 */
    isHour: {
      type: Boolean,
      default: true,
    },
    /** 凡例表示 */
    isLegend: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** 表示フラグ */
    dspFlg: {
      get() {
        return this.$store.state.Telemeter.selectedTm.tmStgDetailInfo.dspFlg;
      },
    },
    crossConfig: {
      get() {
        return this.$store.state.app.config.crossConfig;
      },
    },
    surfaceInfo: {
      get() {
        return {
          surfaceConf: this.$store.state.Telemeter.surfaceConf,
          surface: this.$store.state.Telemeter.surface,
        };
      },
    },
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTime,
          ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
          itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
          obsCd: this.$store.state.Telemeter.selectedTmParam.selectedTm,
        };
      },
    },
    /**
     * スライダーの最大値を取得
     */
    sliderMax: {
      get() {
        var max = this.xsecList.length - 1;
        if (
          this.surfaceInfo.surface.trPredStg &&
          this.surfaceInfo.surface.trPredStg.length !== 0
        ) {
          max += this.surfaceInfo.surface.trPredStg.length * this.predStep;
        }
        if (max < 0) {
          max = 0;
        }
        return max;
      },
    },
    sliderIndex: {
      get() {
        let index = 0;
        let itemLength = this.xsecList.length;
        if (this.sliderIdx >= 0) {
          if (this.sliderIdx >= itemLength) {
            if (this.surfaceInfo.surface.trPredStg) {
              let num = Math.floor(
                (this.sliderIdx - itemLength) / this.predStep
              );
              index = itemLength + num;
            }
          } else {
            index = this.sliderIdx;
          }
        }
        return index;
      },
    },
    sliderText: {
      get() {
        let text = "";
        let index = this.sliderIndex;
        let itemList = this.xsecList;
        let itemLength = itemList.length - 1;
        if (itemLength > 0) {
          if (index <= itemLength) {
            text = itemList[itemLength - index].date;
          } else {
            if (this.surfaceInfo.surface.trPredStg) {
              let idp =
                this.surfaceInfo.surface.trPredStg.length -
                (index - itemLength);
              text = this.formatSurfaceValue(
                this.surfaceInfo.surface.trPredStg[idp].date
              );
            }
          }
        }
        return text;
      },
    },
    xsecList: {
      get() {
        if (this.selectTime) {
          this.$log.debug("=== trStg1h ===");
          return this.surfaceInfo.surface.trStg1h;
        } else {
          this.$log.debug("=== trStg10m ===");
          return this.surfaceInfo.surface.trStg10m;
        }
      },
    },
    sliderStep: {
      get() {
        let step = 1;
        let itemLength = this.xsecList.length;
        if (this.sliderIdx >= itemLength + this.predStep - 1) {
          if (this.surfaceInfo.surface.trPredStg) {
            step = this.predStep;
          }
        }
        return step;
      },
    },
    mode: {
      get() {
        return this.$store.state.app.mode;
      },
    },
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.selectTime = this.isHour;
    this.selectDisp = this.isExpansion;
    this.isLegendDisp = this.isLegend;

    this.handleResize();

    this.getSurfaceInfo();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    /**
     * リクエスト条件が変更時
     */
    reqParam() {
      this.$log.debug("watch(reqParam)");
      // APIから横断描画に必要な情報を再取得
      this.getSurfaceInfo();
    },
    selectTime() {
      this.$log.debug("watch(selectTime)");
      // APIから横断描画に必要な情報を再取得
      this.getSurfaceInfo();
    },
    /**
     * 横断設定・横断データの変更時
     */
    surfaceInfo() {
      this.$log.debug("watch(surfaceInfo)");
      this.$log.dir(this.surfaceInfo.surface.stgobs);

      // データが0件の場合は処理しない
      if (this.xsecList.length == 0) {
        this.isDispCross = false;
        return;
      }

      // スライダーの初期値設定
      if (this.isHour) {
        this.sliderIdx = this.surfaceInfo.surface.trStg1h.length - 1;
      } else {
        this.sliderIdx = this.surfaceInfo.surface.trStg10m.length - 1;
      }

      if (this.surfaceInfo.surface.stgobs.drawType == 0) {
        // 横断図描画種別が横断図なしの場合は描画しない。
        this.isDispCross = true;
        return;
      } else if (this.surfaceInfo.surface.stgobs.drawType == 2) {
        // 特殊横断描画時は、直接描画処理を呼び出す
        var cross = tmObs.getXsecSpecialCross(
          this.surfaceInfo,
          this.crossConfig,
          this.stgModeCheck(),
          this.mode
        );
        cross.stages = this.xsecList;
        cross.stagesPrediction = this.surfaceInfo.surface.trPredStg;

        this.isScrollMode = false;
        this.cross = cross;
        this.isDispCross = true;
        return;
      }

      // riverInfo生成
      var riverInfo = tmObs.getXsecRiverInfo(
        this.surfaceInfo,
        this.crossConfig
      );

      this.$log.debug("=== riverInfo ===");
      this.$log.dir(riverInfo.points);

      // AB点を設定
      if (
        !this.surfaceInfo.surfaceConf ||
        this.surfaceInfo.surfaceConf.locationA.length === 0
      ) {
        this.isDispCross = true;
        return;
      }

      var arr = tmObs.getXsecArr(this.surfaceInfo);
      var present = tmObs.getXsecPresent(this.surfaceInfo);

      // 描画処理を実行
      geodesic.createCossSectionData(
        arr,
        present,
        riverInfo,
        this.makeCrossData
      );
    },
    sliderIdx() {
      var addStep =
        this.predStep -
        ((this.sliderIdx - this.xsecList.length + 1) % this.predStep);
      if (this.surfaceInfo.surface.trPredStg) {
        if (this.sliderIdx >= this.xsecList.length && addStep < this.predStep) {
          this.sliderIdx += addStep;
        }
      }
    },
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.graphBox !== undefined) {
          const offsetWidth = this.$refs.graphBox.offsetWidth;
          const offsetHeight = this.$refs.graphBox.offsetHeight;
          if (offsetWidth > 0 && offsetHeight > 0) {
            this.width = offsetWidth - 48;
            this.height = offsetHeight - 70;
          }
        }
      });
    },
    getSurfaceInfo() {
      this.$log.debug("=== getSurfaceInfo ===");
      setTimeout(() => {
        let param = {
          appTime: this.reqParam.appTime,
          ofcCd: this.reqParam.ofcCd,
          itmkndCd: this.reqParam.itmkndCd,
          obsCd: this.reqParam.obsCd,
          distanceP: this.crossConfig.distanceP,
          limit: this.crossConfig.limit,
          point1Info: WebStorage.getPoint1Info(),
          point2Info: WebStorage.getPoint2Info(),
          point3Info: WebStorage.getPoint3Info(),
          point4Info: WebStorage.getPoint4Info(),
          point5Info: WebStorage.getPoint5Info(),
        };
        this.$store.dispatch("Telemeter/getSurfaceData", param);
      }, 500);
    },
    makeCrossData(self) {
      this.$log.debug("makeCrossData");
      this.$log.dir(self.riverInfo);

      // 横断図描画データの作成
      drawCross.createData(self._data, self.riverInfo);
      this.$log.dir(self.riverInfo.points);

      // 描画ライブラリに渡すデータを生成
      var cross = tmObs.getXsecCross(self, this.stgModeCheck(), this.mode);
      cross.stages = this.xsecList;
      cross.stagesPrediction = this.surfaceInfo.surface.trPredStg;

      this.cross = cross;
      this.isDispCross = true;
    },
    // 凡例クリックイベント
    handleLegend() {
      this.$log.debug("handleLegend");
      this.isShowLegend = !this.isShowLegend;
    },
    // 観測日時(予測値)フォーマット
    formatSurfaceValue(value) {
      return value + "（予測値）";
    },
    // prependアイコン有効判定
    ablePrepend() {
      if (this.sliderIdx > 0) {
        return true;
      } else {
        return false;
      }
    },
    // prependアイコンクリックイベント
    prependCross() {
      if (this.ablePrepend()) {
        if (this.sliderIdx > this.xsecList.length) {
          this.sliderIdx -= this.predStep;
        } else {
          this.sliderIdx -= 1;
        }
      }
    },
    // appendアイコン有効判定
    ableAppend() {
      if (this.sliderIdx < this.sliderMax) {
        return true;
      } else {
        return false;
      }
    },
    // appendアイコンクリックイベント
    appendCross() {
      if (this.ableAppend()) {
        if (this.sliderIdx >= this.xsecList.length) {
          this.sliderIdx += this.predStep;
        } else {
          this.sliderIdx += 1;
        }
      }
    },
    // 横断図の堤防天端、零点高の表示判定処理
    //  デフォルトは零点高だが、堤防天端の表示設定がされている場合は堤防天端で描画する
    stgModeCheck() {
      let stgModeflg = "0";
      if (this.dspFlg === 1) {
        if (this.stgMode === "1") {
          stgModeflg = "1";
        }
      }
      return stgModeflg;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
